import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 28, once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, className = "", align = "left" }) {
  return (
    <div className={`${align === "center" ? "text-center" : ""} ${className}`}>
      {eyebrow && (
        <Reveal>
          <p className="eyebrow mb-4 flex items-center gap-3">
            {align === "center" && <span className="inline-block h-px w-8 bg-copper/60" aria-hidden="true" />}
            {eyebrow}
            <span className="inline-block h-px w-8 bg-copper/60" aria-hidden="true" />
          </p>
        </Reveal>
      )}
      <Reveal delay={0.08}>
        <h2 className="display-title text-4xl sm:text-5xl lg:text-6xl">{title}</h2>
      </Reveal>
    </div>
  );
}

export function MaskedLine({ children, index = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.95, delay: 0.25 + index * 0.14, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
}
